import React, { useState } from "react";
// External dependencies
import MonthPicker from "../../components/version/MonthPicker";
// Internal Dependencies
import {
  Column,
  Row,
} from "../../components/common/template/ColumnRowGenerator";
import SubHeaderTitle from "../../components/common/headings/SubHeaderTitle";
import Wrapper from "../../components/common/wrapper/Wrapper";
import WrapperContent from "../../components/common/wrapperContent/WrapperContent";
import WrapperSubHeader from "../../components/common/wrapperSubHeader/WrapperSubHeader";
import GlobalSearchBar from "../../components/common/GlobalSearchBar/GlobalSearchBar";
import WrapperCard from "../../components/common/wrapperCard/WrapperCard";
import WrapperCardHeader from "../../components/common/wrapperCard/WrapperCardHeader";
import BlockQuote, { ChangeLogDTO, ChangeLogItemDTO } from "../../components/version/BlockQuote";

interface VersionProps {
  navUrl: string; 
}

export interface VersionData {
  changeLogDTO: ChangeLogDTO;
  changeLogItemDTOs: ChangeLogItemDTO[];
}

const Version: React.FC<VersionProps> = ({ navUrl }) => {
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [versionData, setVersionData] = useState<VersionData[]>([]);
  const [lastUpdated, setlastUpdated] = useState<string>("");

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  return (
    <>
      <Wrapper navUrl={navUrl}>
        <WrapperSubHeader>
          <Column md={8}>
            <SubHeaderTitle
              subTitle={navUrl}
              listArray={[{ "Last Updated": lastUpdated }]}
            />
          </Column>
          <Column md={2}>
            <MonthPicker
              setlastUpdated={setlastUpdated}
              setVersionData={setVersionData}
            />
          </Column>
          <Column md={2} className="pl-md-0 mt-1 mt-md-0">
            {/* GlobalSearchBar Component: Reusable search bar with custom
            styling and functionality for global search */}
            <GlobalSearchBar
              subId="searchInput"
              onChange={handleInputChange}
              className="mr-1 mobile-search-box"
              subClassName="m-input search-icons"
              placeholder={"Search List..."}
              value={searchTerm}
              aria-describedby="basic-addon2"
            />
          </Column>
        </WrapperSubHeader>
        <WrapperContent>
          <Row>
            <WrapperCard>
              <WrapperCardHeader>
                <div className="m-portlet__head-caption">
                  <div className="m-portlet__head-title">
                   VasyERP is constantly being updated with new features and
                    adjustments. You can always view the most recent update
                    information in this changelog.
                  </div>
                </div>
              </WrapperCardHeader>
              <div className="m-portlet__body card-body-sm" id="searchableDiv">
                <Row>
                  <Column md={12} className="changelogdiv">
                    <BlockQuote searchTerm={searchTerm} versionData={versionData} />
                  </Column>
                </Row>
              </div>
            </WrapperCard>
          </Row>
        </WrapperContent>
      </Wrapper>
    </>
  );
};

export default Version;